<template>
  <div class="diagnosis-draft">
    <div class="shadow-sm p-3 mb-4 bg-light">
      <h4 class="mb-3">{{ $t(type) }} {{ $t("diagnosis") }}</h4>
      <table class="table table-hover table-bordered">
        <thead>
          <tr>
            <th>ICD10</th>
            <th>{{ $t("name") }}</th>
          </tr>
        </thead>
        <tbody v-if="diagnosis">
          <tr v-for="c of diagnosis.conditions" :key="c.code">
            <td>
              {{ c.code }}
            </td>
            <td>
              {{ c.name[authLocale] }}
            </td>
          </tr>
          <tr>
            <td colspan="2">
                <strong class="d-block pb-2">{{ $t("comment") }}</strong>
                <span class="text-monospace">{{ diagnosis.comment }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    value: {
      type: String,
      required: true
    },
    itemId: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters({
      authLocale: 'auth/locale',
      diagnosisById: 'pcase/diagnosisById',
      caseById: 'pcase/byId'
    }),
    diagnosis () {
      return this.diagnosisById(this.value)(this.itemId)
    }
  }
}
</script>
<style lang="scss">
.diagnosis {
  .probable-conditions {
    .probable-condition {
      z-index: 11;
      position: relative;
      .badge {
        width: 35px;
      }
    }
    .progress-bar {
      height: 100%;
      position: absolute;
      left: 0;
      background-color: #3c88ff55;
      top: 0;
      z-index: 10;
    }
  }
  .disease-list {
    max-height: 400px;
    overflow: auto;
  }
  .create-btn {
    color: #fff;
  }
  .list-item {
    display: block;
    // border-top: 1px solid #ccc;
    color: #555;
    text-decoration: none;
    svg {
      transition: all 0.2s;
      width: 24px;
      height: 24px;
    }
    .case-open {
      transform: rotate(180deg);
    }
  }
}
</style>
<i18n>
{
  "ka": {
    "diagnosis": "დიაგნოზი",
    "createPrediagnosis": "წინასწარი დიაგნოზის შექმნა",
    "createDiagnosis": "საბოლოო დიაგნოზი",
    "preliminary": "წინასწარი",
    "final": "საბოლოო",
    "condition": "დაავადება",
    "conditions": "დაავადებები",
    "comment": "დასკვნა",
    "save": "დამატება",
    "publish": "გამოქვეყნება",
    "delete": "წაშლა",
    "search": "ძიება",
    "addDisease": "დაავადების დამატება",
    "name": "დასახელება",
    "save": "შენახვა"
  },
  "en": {
    "diagnosis": "Diagnosis",
    "createPrediagnosis": "Create Preliminary Diagnosis",
    "createDiagnosis": "Create Diagnosis",
    "preliminary": "Preliminary Diagnosis",
    "final": "Final",
    "condition": "Condition",
    "conditions": "Conditions",
    "comment": "Comment",
    "save": "Save",
    "publish": "Publish",
    "delete": "Delete",
    "search": "Search",
    "addDisease": "Add Disease",
    "name": "Name",
    "save": "Save"
  }
}
</i18n>
